<script setup lang="ts">
import device from '@@/bits/device'
import SurfaceApp from '@@/vuecomponents/SurfaceApp.vue'
import { nextTick, onBeforeMount, ref } from 'vue'

const isReadyToMount = ref<boolean>(false)

onBeforeMount(async () => {
  // We need an nextTick here to let the pinia and vuex store finish intializing
  // to prevent a race condition where the SurfaceApp mounts but certain states are not yet available
  await nextTick()
  isReadyToMount.value = true
})

if (device.app) {
  import('@@/vuecomposables/native_bridge_listeners').then(({ useNativeBridgeListeners }) => {
    useNativeBridgeListeners({ for: 'surface' })
  })
}
</script>

<template>
  <SurfaceApp v-if="isReadyToMount" />
</template>
